export default {
  goToForgotPassword: "Elfelejtette jelszavát?",
  goToLoginFromForgotten: "Emlékszik már?",
  goToLoginFromLogin: "Már regisztrált?",
  logout: "Kijelentkezés",

  // Generic fields
  email: "E-mail",
  password: "Jelszó",
  passwordConfirm: "Jelszó megerősítés",
  recoveryKey: "Regisztrációs kód",
  currentPassword: "Jelenlegi jelszó",
  newPassword: "Új jelszó",
  newPasswordConfirm: "Új jelszó megerősítése",

  // Component specific scopes.
  login: {
    invalidLogin: "Hibás email cím vagy jelszó.",
    intro1: "Hemofíliás betegek számára egy mobiltelefonos alkalmazás. Ebben a beteg saját magának követi – jegyzi be – a gyógyszer fogyasztást, és egyéb a kezeléssel kapcsolatos fontos eseményeket (pl.: bevérzés, orvosi vizit, gyógytorna).",
    intro2: "A beteget beregisztráló orvos valós időben nyomon tudja követni a hemofíliás kezelésével kapcsolatos adatokat, így a jövőben, akár több évre visszamenőleg láthatja például, hogy mikor volt a páciensnek műtéte, bevérzése, milyen gyógyszereket, és milyen mennyiségben fogyasztott, stb. Azok a betegek, akik az alkalmazást fegyelmezetten használják, részletes, és nagyon hasznos kórtörténetet fognak orvosuk számára készíteni, ami rendkívül hasznos lesz a jövőbeni személyre szabott terápiás kezeléshez.",
    title: "Bejelentkezés",
    action: "Bejelentkezés",
    email: "Email",
    password: "Jelszó",
  },
  passwordResetRequest: {
    title: "Elfelejtett jelszó",
    success: "A jelszó visszaállításához szükséges linket e-mailben elküldtük önnek.",
    action: "Jelszó visszaállítása",
    emailNotFound: "Az email cím nem található.",
  },
  passwordReset: {
    title: "Elfelejtett jelszó",
    action: "Elküld",
    loginAction: "Bejelentkezés",
    success: "Sikeres jelszóváltoztatás!",
    recoveryKeyHint: "Ezt a regisztrációs folyamat végén kapta meg.",
  },
  changeEmail: {
    title: "E-mail módosítás",
  },
  changePassword: {
    title: "Jelszó módosítás"
  },
  signup: {
    title: "Regisztráció",
    eula: {
      prefix: "Elolvastam és elfogadom a",
      label: "Felhasználási feltételek",
      hint: "Elolvastam és elfogadom a Felhasználási Feltételeket.",
      required: "A folytatáshoz el kell fogadnia a felhasználási feltételeket",
    },
    privacyPolicy: {
      prefix: "Elolvastam és elfogadom az",
      label: "Adatkezelési nyilatkozat",
      hint: "Elolvastam és elfogadom az Adatkezelési Szabályzatot.",
      required: "A folytatáshoz el kell fogadnia az adatkezelési szabályzatot.",
    },
    recoveryKeyHint: "Amennyiben elveszíti hozzáférését, ezzel a kóddal tudja visszaszerezni.",
    recoveryReminder: {
      title: "Elmentette regisztrációs kódját?",
      body: "Kérjük nyomtassa ki és tárolja biztonságos helyen az alábbi regisztrációs kódot. Csak ennek a segítségével tudja visszaállítani az adatait, amennyiben elveszti hozzáférését!",
    },
    errorUnknown: "A regisztrációt nem lehetett befejezni.",
    errorInvalidCode: "Hibás kód.",
    aggreedMarketingAccess: "Hozzájárulok, hogy új szolgáltatásokról és egyéb hírekről e-mail-ben tájékoztasson a Hemonapló.",
    loginAction: "Bejelentkezés"
  },
  recoveryDownload: {
    title: "Regisztrációs kód letöltés",
    hint: "A kód letöltésével jelszavának elfelejtése esetén is vissza tudja állítani hozzáférését a fiókjához. Ezt a fájlt tárolja biztonságos helyen, másoktól elzárva.",
    download: "Letölés"
  }
}